import { getEnv } from './environments';

interface GlobalEventType {
    id: string;
    action: string;
    details: string;
}

export const globalEvents = {
    entertainment: {
        id: 'ajx4',
        action: 'navigateTo',
        details: getEnv('VITE_WEBVIEW_PARADIGMA_ENTERTAINMENT'),
    },
    changeQuota: {
        id: 'ajx4',
        action: 'navigateTo',
        details: getEnv('VITE_WEBVIEW_PARADIGMA_POSTSALES'),
    },
};

export const triggerGlobalEvent = (globalEvent: GlobalEventType) => {
    window?.top?.postMessage(globalEvent, '*');
};
